import {Body, Head} from "./lib";
import {Box} from "react-feather";
import {Fragment} from "react/jsx-runtime";
import {get} from "global/slices/clients/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import InfiniteScroll from "react-infinite-scroll-component";
import {TableContainer, Table as MUITable} from "@mui/material";
import {
  Loader,
  Column,
  Skeleton,
  EndMessage,
  ComponentLoader,
} from "components";

interface TableProps {}

export const Table: React.FC<TableProps> = () => {
  const dispatch = useAppDispatch();
  const {clientProductsPagination, clientProducts, request} =
    useAppSelector("clients");
  const pagination = clientProductsPagination;
  const {hasMore, ser} = pagination;
  const emptyMessage = ser
    ? "No se han encontrado productos"
    : "No hay productos creados";

  return (
    <div style={{width: "100%"}}>
      <InfiniteScroll
        loader={<Loader />}
        hasMore={hasMore as boolean}
        dataLength={clientProducts["length"]}
        scrollableTarget="scrollable"
        style={{marginBottom: !clientProducts["length"] ? "1rem" : undefined}}
        next={() => dispatch(get({...pagination, pos: pagination["pos"] + 1}))}
        endMessage={
          !clientProducts["length"] ? (
            <Fragment />
          ) : (
            <EndMessage data={clientProducts} />
          )
        }
      >
        <ComponentLoader
          requestStatus={request["clientProducts"]}
          skeleton={
            <Column width="100%">
              <Skeleton height={60} width="100%" />
              <Column gap={2} width="100%">
                <Skeleton count={5} height={68} width="100%" />
              </Column>
            </Column>
          }
          emptyUI={{
            icon: Box,
            data: clientProducts,
            message: emptyMessage,
            style: {width: "100%"},
          }}
        >
          <TableContainer>
            <MUITable size="medium" sx={{minWidth: 750}}>
              <Head />
              <Body />
            </MUITable>
          </TableContainer>
        </ComponentLoader>
      </InfiniteScroll>
    </div>
  );
};
